import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css"; // Add CSS styling for the navbar

const navbarHealth = (feedHealth) => {
  switch (feedHealth?.status) {
    case "degraded":
      return { label: "Data degraded", className: "degraded" };
    case "unavailable":
      return { label: "Data unavailable", className: "unavailable" };
    case "recovering":
      return { label: "Data recovering", className: "recovering" };
    case "idle":
      return { label: "Off hours", className: "idle" };
    default:
      return { label: "Live", className: "healthy" };
  }
};

const Navbar = ({ feedHealth }) => {
  const location = useLocation();
  const health = navbarHealth(feedHealth);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <span className="navbar-mark" aria-hidden="true">CL</span>
          <span>Caltrain Live</span>
        </Link>
        <ul className="navbar-links">
          <li>
            <Link
              to="/"
              className={`navbar-link ${
                location.pathname === "/" ? "active" : ""
              }`}
            >
              Live trains
            </Link>
          </li>
          <li>
            <Link
              to="/planner"
              className={`navbar-link ${
                location.pathname.startsWith("/planner") ? "active" : ""
              }`}
            >
              Trip Planner
            </Link>
          </li>
          <li className="navbar-mobile-health-item">
            <Link
              to="/health"
              className={`navbar-link ${
                location.pathname === "/health" ? "active" : ""
              }`}
            >
              Data status
            </Link>
          </li>
        </ul>
        <div className="navbar-health-actions">
          <span className={`navbar-status ${health.className}`}>
            <span className="live-dot" />{health.label}
          </span>
          <Link to="/health" className="navbar-health-link">
            511.org API feed health
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
